import { UIGameBaseTileController } from './UIGameTileControllerBase.ts';
import { UIGameGeneralShoreTileController } from './UIGameGeneralShoreTileController.ts';
import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
import { HiddenUIElement, getWaitMSForAction } from '@colonist/game-beginner-mode';
import { UIGameFlickerAnimation } from '../../ui_canvas_engine/animation/UIGameFlickerAnimation.ts';
import { TileHexType } from '@colonist/game-states';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
import { UIGameGoToPointAnimation } from '../../ui_canvas_engine/animation/UIGameGoToPointAnimation.ts';
export class UIGameGeneralTileController extends UIGameBaseTileController {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.DiceStateUpdated:
                this.rolledTile(data);
                break;
            case UIGameEventEnums.MapStateUpdated:
                this.updateDiceProbabilities();
                break;
            case UIGameEventEnums.BeginnerModeStart:
                this.onBeginnerModeStart();
                break;
            case UIGameEventEnums.BeginnerModeActionUpdated:
                this.onBeginnerModeActionUpdate(data);
                break;
            case UIGameEventEnums.DiceNumberAnimationEnd:
                this.onDiceNumberAnimationEnd(data);
                break;
            default:
                break;
        }
    }
    drawTiles() {
        for (const tile of this.uiGameManager.gameState.mapState.tileState.tiles){
            const tileView = this.drawTile(tile);
            this.uiGameManager.mapController.tileViews.push(tileView);
        }
    }
    rolledTile(animate) {
        if (!this.uiGameManager.gameController.diceState.diceThrown) return;
        if (!animate) return;
        const diceNumber = this.uiGameManager.gameController.diceState.dice1 + this.uiGameManager.gameController.diceState.dice2;
        for (const tile of this.uiGameManager.gameState.mapState.tileState.tiles){
            if (tile.diceNumber != diceNumber) continue;
            const tileView = this.uiGameManager.mapController.getTileViewForHexFace(tile.hexFace);
            if (tileView == undefined) continue;
            this.tilesToHighlight.push(tileView);
        }
        if (this.isBeginnerModeEnabled) return;
        this.animateTiles();
    }
    animateTiles() {
        const animationDuration = 2;
        for (const tileView of this.tilesToHighlight){
            tileView.highlightTileForTime(animationDuration);
        }
        this.tilesToHighlight = [];
    }
    updateDiceProbabilities() {
        const tileViewsUpdatingDiceNumbers = this.getTileViewsUpdatingDiceProbabilities();
        if (tileViewsUpdatingDiceNumbers.length == 0) return;
        if (this.areDiceNumbersSwapping(tileViewsUpdatingDiceNumbers)) {
            this.animateDiceNumbersSwapping(tileViewsUpdatingDiceNumbers);
            return;
        }
        this.redrawDiceProbability(tileViewsUpdatingDiceNumbers);
    }
    areDiceNumbersSwapping(tileViewsUpdatingDiceNumbers) {
        var _tile1ProbabilityView_swapDiceProbabilityAnimation, _tile2ProbabilityView_swapDiceProbabilityAnimation, _this_uiGameManager_gameController_mapValidator_tileState_getTileHex, _this_uiGameManager_gameController_mapValidator_tileState_getTileHex1;
        if (tileViewsUpdatingDiceNumbers.length != 2) return false;
        const tile1ProbabilityView = tileViewsUpdatingDiceNumbers[0].probabilityView;
        const tile2ProbabilityView = tileViewsUpdatingDiceNumbers[1].probabilityView;
        const isExistingAnimationInProgress = (tile1ProbabilityView === null || tile1ProbabilityView === void 0 ? void 0 : (_tile1ProbabilityView_swapDiceProbabilityAnimation = tile1ProbabilityView.swapDiceProbabilityAnimation) === null || _tile1ProbabilityView_swapDiceProbabilityAnimation === void 0 ? void 0 : _tile1ProbabilityView_swapDiceProbabilityAnimation.isAnimationInProgress) === true || (tile2ProbabilityView === null || tile2ProbabilityView === void 0 ? void 0 : (_tile2ProbabilityView_swapDiceProbabilityAnimation = tile2ProbabilityView.swapDiceProbabilityAnimation) === null || _tile2ProbabilityView_swapDiceProbabilityAnimation === void 0 ? void 0 : _tile2ProbabilityView_swapDiceProbabilityAnimation.isAnimationInProgress) === true;
        if (isExistingAnimationInProgress) {
            var _tile1ProbabilityView_swapDiceProbabilityAnimation1, _tile2ProbabilityView_swapDiceProbabilityAnimation1;
            tile1ProbabilityView === null || tile1ProbabilityView === void 0 ? void 0 : (_tile1ProbabilityView_swapDiceProbabilityAnimation1 = tile1ProbabilityView.swapDiceProbabilityAnimation) === null || _tile1ProbabilityView_swapDiceProbabilityAnimation1 === void 0 ? void 0 : _tile1ProbabilityView_swapDiceProbabilityAnimation1.stop();
            tile2ProbabilityView === null || tile2ProbabilityView === void 0 ? void 0 : (_tile2ProbabilityView_swapDiceProbabilityAnimation1 = tile2ProbabilityView.swapDiceProbabilityAnimation) === null || _tile2ProbabilityView_swapDiceProbabilityAnimation1 === void 0 ? void 0 : _tile2ProbabilityView_swapDiceProbabilityAnimation1.stop();
            return this.areDiceNumbersSwapping(tileViewsUpdatingDiceNumbers);
        }
        const tile1OriginalDiceNumber = tileViewsUpdatingDiceNumbers[0].diceNumber;
        const tile2OriginalDiceNumber = tileViewsUpdatingDiceNumbers[1].diceNumber;
        const tile1NewDiceNumber = (_this_uiGameManager_gameController_mapValidator_tileState_getTileHex = this.uiGameManager.gameController.mapValidator.tileState.getTileHex(tileViewsUpdatingDiceNumbers[0].hexFace)) === null || _this_uiGameManager_gameController_mapValidator_tileState_getTileHex === void 0 ? void 0 : _this_uiGameManager_gameController_mapValidator_tileState_getTileHex.diceNumber;
        const tile2NewDiceNumber = (_this_uiGameManager_gameController_mapValidator_tileState_getTileHex1 = this.uiGameManager.gameController.mapValidator.tileState.getTileHex(tileViewsUpdatingDiceNumbers[1].hexFace)) === null || _this_uiGameManager_gameController_mapValidator_tileState_getTileHex1 === void 0 ? void 0 : _this_uiGameManager_gameController_mapValidator_tileState_getTileHex1.diceNumber;
        if (tile1OriginalDiceNumber != tile2NewDiceNumber) return false;
        if (tile2OriginalDiceNumber != tile1NewDiceNumber) return false;
        return true;
    }
    getTileViewsUpdatingDiceProbabilities() {
        const tileViewsBeingUpdated = [];
        for (const tileHex of this.uiGameManager.gameState.mapState.tileState.tiles){
            var _tileView_probabilityView;
            const tileView = this.uiGameManager.mapController.getTileViewForHexFace(tileHex.hexFace);
            if (tileView == undefined) continue;
            const isTileDiceProbabilityViewAnimating = ((_tileView_probabilityView = tileView.probabilityView) === null || _tileView_probabilityView === void 0 ? void 0 : _tileView_probabilityView.swapDiceProbabilityAnimation) !== undefined;
            const isDiceNumberSame = tileView.diceNumber == tileHex.diceNumber;
            if (isDiceNumberSame && !isTileDiceProbabilityViewAnimating) continue;
            tileViewsBeingUpdated.push(tileView);
        }
        return tileViewsBeingUpdated;
    }
    animateDiceNumbersSwapping(tileViews) {
        if (tileViews.length != 2) return;
        const firstProbabilityView = tileViews[0].probabilityView;
        const secondProbabilityView = tileViews[1].probabilityView;
        if (firstProbabilityView == undefined) return;
        if (secondProbabilityView == undefined) return;
        const firstProbabilityViewStartingPosition = tileViews[0].getDiceProbabilityMapPoint();
        if (firstProbabilityViewStartingPosition == undefined) return;
        const secondProbabilityViewStartingPosition = tileViews[1].getDiceProbabilityMapPoint();
        if (secondProbabilityViewStartingPosition == undefined) return;
        const firstDiceNumber = tileViews[0].diceNumber;
        if (firstDiceNumber == undefined) return;
        const secondDiceNumber = tileViews[1].diceNumber;
        if (secondDiceNumber == undefined) return;
        this.createSwapDiceProbabilityAnimation(firstProbabilityView, firstProbabilityViewStartingPosition, secondProbabilityViewStartingPosition, firstDiceNumber, tileViews[1]);
        this.createSwapDiceProbabilityAnimation(secondProbabilityView, secondProbabilityViewStartingPosition, firstProbabilityViewStartingPosition, secondDiceNumber, tileViews[0]);
    }
    createSwapDiceProbabilityAnimation(diceProbabilityView, startingPosition, endPosition, originalDiceNumber, newTileView) {
        if (diceProbabilityView.parent != undefined) diceProbabilityView.parent.removeChild(diceProbabilityView);
        this.uiGameManager.mapController.mapView.addChild(diceProbabilityView);
        diceProbabilityView.x = startingPosition.x;
        diceProbabilityView.y = startingPosition.y;
        diceProbabilityView.swapDiceProbabilityAnimation = new UIGameGoToPointAnimation(diceProbabilityView, endPosition, 0.5);
        diceProbabilityView.swapDiceProbabilityAnimation.setOnStopCallback(()=>{
            if (diceProbabilityView.parent != undefined) diceProbabilityView.parent.removeChild(diceProbabilityView);
            newTileView.drawProbability(originalDiceNumber);
        });
        diceProbabilityView.swapDiceProbabilityAnimation.start();
    }
    redrawDiceProbability(tileViews) {
        for (const tileView of tileViews){
            const tileHex = this.uiGameManager.gameState.mapState.tileState.getTileHex(tileView.hexFace);
            if (tileHex == undefined) continue;
            tileView.drawProbability(tileHex.diceNumber);
        }
    }
    onBeginnerModeStart() {
        this.isBeginnerModeEnabled = true;
        for (const tileView of this.uiGameManager.mapController.tileViews)if (tileView.probabilityView != undefined) tileView.probabilityView.visible = false;
        for (const tile of this.uiGameManager.gameState.mapState.tileState.tiles){
            if (tile.tileType != TileHexType.Gold) continue;
            const tileView = this.uiGameManager.mapController.getTileViewForHexFace(tile.hexFace);
            if (tileView == undefined) continue;
            new UIGameFlickerAnimation(tileView).start();
        }
    }
    onBeginnerModeActionUpdate(data) {
        const baseWaitMS = 1300;
        this.probabilityViewAnimationWaitMS = getWaitMSForAction(baseWaitMS, data.actionIndex);
        const areProbabilityViewsStillHidden = data.hiddenUIElements.includes(HiddenUIElement.TileProbabilityViews);
        if (areProbabilityViewsStillHidden) return;
        this.revealProbabilityViews();
    }
    revealProbabilityViews() {
        for (const tileView of this.uiGameManager.mapController.tileViews){
            if (tileView.probabilityView != undefined) tileView.probabilityView.visible = true;
        }
    }
    onDiceNumberAnimationEnd(data) {
        if (data == undefined) return this.uiGameManager.eventController.sendEvent(undefined, UIGameEventEnums.TileNumberAnimationEnd);
        this.animateTiles();
        const totalDiceNumber = this.uiGameManager.gameController.diceState.dice1 + this.uiGameManager.gameController.diceState.dice2;
        for (const tileView of this.uiGameManager.mapController.tileViews){
            if (tileView.diceNumber != totalDiceNumber) continue;
            if (tileView.probabilityView == undefined) continue;
            const probabilityViewAnimation = new UIGameFlickerAnimation(tileView.probabilityView, this.probabilityViewAnimationWaitMS);
            probabilityViewAnimation.setOnStopCallback(()=>this.uiGameManager.eventController.sendEvent(undefined, UIGameEventEnums.TileNumberAnimationEnd));
            probabilityViewAnimation.start();
        }
    }
    constructor(uiGameManager){
        super(uiGameManager), this.probabilityViewAnimationWaitMS = 1300, this.isBeginnerModeEnabled = false;
        this.uiGameManager.eventController.registerUIGameMechanic(this);
        this.tilesToHighlight = [];
        this.drawTiles();
        new UIGameGeneralShoreTileController(this.uiGameManager, this.uiGameManager.gameController.mapValidator.fogTileGroupStates);
    }
}
